<template>
	<div class='lmAes-acton'>
    <h2>MoPaaS 大模型应用引擎：智能体应用（Acton）</h2>
    <div class="box">
      <div class="content">
        <p>·基于开放的模型上下文协议 (MCP)</p>
        <p>·智能体-大模型高效协同；</p>
        <p>·易于开发和接入新智能体;</p>
        <p>·智能体系统-环境反馈闭环;</p>
        <p>·推理、安全与对齐；</p>
        <p>·灵活构建复杂的业务逻辑和工作流。</p>
      </div>
      <img src="../assets/images/lmaesActon.png"/>
      </div>
	</div>
</template>

<script>
	export default {
		name: 'LmAesActon'
	}
</script>

<style scoped>
  @media(min-width:992px) {
    .lmAes-acton {
      background: #ffffff;
      padding: 4.16vw 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .lmAes-acton h2 { 
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #3963B3;
      line-height: 33px;
      text-align: left;
      font-style: normal;
    }
    .lmAes-acton .box {
      width: 100%;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lmAes-acton .box img {
      width: 44.17vw;
      height: 21.94vw;
    }
    .lmAes-acton .box .content {
      width: 22.5vw;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmAesActon.vue